import { useState } from 'react';
import { Loader2, ShieldCheck } from 'lucide-react';
import { fmt } from './chatAccessI18n';

export const inputCls = 'w-full px-3 py-2 border border-slate-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#4A5FC1]';
export const btnCls = 'w-full bg-[#283880] hover:bg-[#1f2c66] disabled:bg-slate-300 text-white text-sm py-2 rounded-lg flex items-center justify-center gap-2 transition-colors';
export const linkBtnCls = 'text-xs text-[#283880] underline hover:text-[#C9A227]';

export const Card = ({ title, children, testId }) => (
  <div className="bg-white border border-[#C9A227]/40 rounded-xl p-3 shadow-sm space-y-2 text-sm text-slate-700" data-testid={testId}>
    {title && (
      <p className="flex items-center gap-2 font-semibold text-[#283880]"><ShieldCheck className="w-4 h-4 text-[#C9A227]" />{title}</p>
    )}
    {children}
  </div>
);

export const ErrorText = ({ text }) => (text ? <p className="text-xs text-red-600" data-testid="chat-access-error">{text}</p> : null);

export const IdentifyStep = ({ t, busy, onSubmit }) => {
  const [value, setValue] = useState('');
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(value); }} className="space-y-2">
      <p className="text-xs text-slate-500">{t.identifyText}</p>
      <input data-testid="chat-access-fiscal-input" className={`${inputCls} uppercase placeholder:normal-case`} value={value} onChange={(e) => setValue(e.target.value)} placeholder={t.fiscalPh} maxLength={16} autoComplete="off" />
      <button data-testid="chat-access-fiscal-submit" disabled={busy || value.trim().length < 11} className={btnCls}>
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}{t.send}
      </button>
    </form>
  );
};

export const OtpStep = ({ t, email, busy, onSubmit, onResend, testPrefix }) => {
  const [code, setCode] = useState('');
  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(code); }} className="space-y-2">
      <p className="text-xs text-slate-500">{fmt(t.otpText, { email })}</p>
      <input data-testid={`${testPrefix}-otp-input`} className={`${inputCls} tracking-[0.4em] placeholder:tracking-normal placeholder:font-normal text-center font-semibold`} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} placeholder={t.otpPh} maxLength={6} inputMode="numeric" autoComplete="one-time-code" />
      <button data-testid={`${testPrefix}-otp-submit`} disabled={busy || code.length !== 6} className={btnCls}>
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}{t.verify}
      </button>
      <button type="button" onClick={onResend} className={linkBtnCls} data-testid={`${testPrefix}-otp-resend`}>{t.resend}</button>
    </form>
  );
};
